import { sortArrayBy } from '@domain-group/javascript-utils'

import type { AgencyModel, ProviderPriceListModel, ServiceCategoryModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

type FilterProductsByPriceListAndStatusParams = {
  agency: AgencyModel,
  providerPriceList: ProviderPriceListModel,
  serviceCategory: ServiceCategoryModel,
  serviceProducts: EntitiesState['serviceProducts'],
}

const filterProductsByPriceListAndStatus = (params: FilterProductsByPriceListAndStatusParams) => {
  const {
    agency, providerPriceList, serviceCategory, serviceProducts,
  } = params

  const activeProductIds = providerPriceList?.active_product_ids || []
  const hiddenProductIds = agency?.options?.hidden_product_ids || []

  const filtered = Object.values(serviceProducts)
    .filter(serviceProduct => (
      !hiddenProductIds.includes(serviceProduct.id)
      && activeProductIds.includes(serviceProduct.id)
      && (!serviceCategory?.id || (serviceProduct.categories && serviceProduct.categories.includes(serviceCategory.id)))
    ))

  const sorted = sortArrayBy(filtered, 'asc', 'title')

  return sorted
}

export default filterProductsByPriceListAndStatus
